import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
    state:{
        show:false,
        name:'',
        producer:'',
        no:'',
        result:null
    }

    ,mutations:{
        pushName(state,value)
        {
            state.name=value;
        },
        pushProducer(state,value)
        {
            state.producer=value;
        },
        pushNo(state,value)
        {
            state.no=value;
        },
        pushResult(state,value)
        {
            state.result=value;
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js